import { useMemo } from 'react';
import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { FacebookAdAccount, GraphQLFacebookAdAccount } from '../types';

export const FetchFBAdAccountIdsQuery = gql`
  query getFacebookAdAccountIds {
    facebookAdAccounts {
      accountId
      id
      projectId
      userId
    }
  }
`;

export const useFetchFBAdAccountIdsQuery = () => {
  const { data, isLoading, error } = useGraphql(FetchFBAdAccountIdsQuery);

  // Convert GraphQLFacebookAdAccount to FacebookAdAccount type
  const fbAdAccounts: FacebookAdAccount[] = useMemo(
    () =>
      (data?.facebookAdAccounts || []).map((account: GraphQLFacebookAdAccount) => {
        const { accountId, ...remainingAccountInfo } = account;
        return {
          ...remainingAccountInfo,
          adAccountId: accountId,
        };
      }),
    [data],
  );

  return {
    fbAdAccounts,
    isLoading,
    error,
  };
};
